import * as moment from 'moment';
import { Component } from '@angular/core';
import { ModalController } from 'ionic-angular';

import { DayEntryModel, UserModel } from '../../../models/models';
import { ConfigurationProvider, DayEntryProvider, UserProvider } from '../../../providers/providers';
import { DashboardNotesPage } from '../dashboard-notes';

@Component({
  selector: 'page-dashboard-activity',
  templateUrl: 'dashboard-activity.html'
})
export class DashboardActivityPage {
  dayEntry: any = null;
  dayEntryList: any = [];
  isLoaded: boolean = false;
  isToday: boolean = true;
  startDate: moment.Moment = moment();
  calDate: string = this.startDate.format('YYYY-MM-DD');
  todayDate: string = moment().format('YYYY-MM-DD');
  user: UserModel;

  constructor(
    private config: ConfigurationProvider,
    private dayEntryProvider: DayEntryProvider,
    private modalCtrl: ModalController,
    private userProvider: UserProvider) {
  }

  doChangeDate(data) {
    this.doChangeDay(0, moment(`${data.month} ${data.day} ${data.year}`));
  }

  doChangeDay(direction: number, newDate: moment.Moment = null) {
    if (!newDate) {
      newDate = direction === 0 ? moment() : moment(this.startDate).add(direction, 'day');
    }
    if (newDate <= moment()) {
      const hasDate = this.dayEntryList.find(x => moment(x.Date).format('YYYY-MM-DD') === newDate.format('YYYY-MM-DD'));
      if (hasDate === undefined) {
        this.loadDayActivity(newDate);
      }
      this.dayEntryProvider.SetDate(newDate);
      this.dayEntry = this.dayEntryProvider.Get(newDate);
      this.isToday = moment(newDate).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD');
      this.calDate = newDate.format('YYYY-MM-DD');
      this.startDate = newDate;
    }
  }

  doEditNotes(dayEntry: DayEntryModel) {
    let modal = this.modalCtrl.create(DashboardNotesPage, { 
      dayEntry: dayEntry,
      user: this.user
    });
    modal.present();

    modal.onDidDismiss(data => {
      if (data && data.saved && data.date) {
        this.config.showToast(`Notes saved for ${data.date}`);
        this.dayEntry.Notes = data.notes;
        this.loadDayActivity(moment(dayEntry.Date), true);
      }
    });
  }

  doSwipe(e) {
    this.doChangeDay(e.direction === 4 ? -1 : 1);
  }

  doSyncActivity() {
    this.config.showLoading();
    this.dayEntryProvider.SyncFitbit(this.dayEntry).then((data: DayEntryModel) => {
      this.dayEntry.FitbitActivityCalories = data.FitbitActivityCalories;
      this.dayEntry.FitbitCalories = data.FitbitCalories;
      this.dayEntry.FitbitDistance = data.FitbitDistance;
      this.dayEntry.FitbitSteps = data.FitbitSteps;
      this.dayEntry.Activities = data.Activities;
      this.config.dismissLoading();
    });
  }

  ionViewDidLoad() {
    this.startDate = moment();
    this.loadView();
  }

  loadDayActivity(startDate: moment.Moment, merge: boolean = false) {
    this.config.showLoading();
    this.isLoaded = false;
    this.dayEntryProvider.Load(this.user._id, startDate, true, merge).then((items: DayEntryModel[]) => {
      this.loadItems(items, startDate);
      this.config.dismissLoading();
    });
  }

  loadItems(items, startDate) {
    this.dayEntry = this.dayEntryProvider.Get(startDate);

    for (let item of this.dayEntry.Activities) {
      if (item.ActivityCount > 0) {
        item.icon = 'arrow-dropdown';
        item.showDetails = false;
      }
    }

    this.dayEntryList = items;
    this.isToday = moment(startDate).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD');
    this.calDate = startDate.format('YYYY-MM-DD');
    this.startDate = startDate;
    this.isLoaded = true;
  }

  loadView() {
    this.user = this.userProvider.Get();
    const date = this.dayEntryProvider.GetDate();
    if (this.user === null || date === undefined) {
      this.config.showLoading();
      this.userProvider.Load(1).then((x: UserModel) => {
        this.user = x;
        this.config.dismissLoading();
        this.loadDayActivity(this.startDate);
      });
    }
    else {
      this.loadItems(this.dayEntryProvider.List(), this.dayEntryProvider.GetDate());
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/dashboard/activity/dashboard-activity.ts